import React from 'react'
import {Box, Flex, Grid, GridItem, Image, Text, Button} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router'

import withProviders from '~/react/contexts/withProviders'

import {colors} from '../../../../../../app/javascript/react/theme/foundations/colors'
import {ArrowRightIcon} from '../../../../../../app/javascript/react/icons'
import backgroundImage from '../../../../../../app/assets/images/onboarding_pillars_background.svg'
import congratsImage from '../../../../../../app/assets/images/congrats.svg'

const WelcomeScreen = () => {
  const {t} = useTranslation('points')
  const navigate = useNavigate()

  return (
    <Grid
      width="100vw"
      height="100vh"
      minHeight="100vh"
      px={{base: 'sm', sm: 'md', lg: 'lg', xl: 'xxl'}}
      backgroundColor="mld.neutral.900"
      backgroundImage={backgroundImage}
      backgroundSize="cover"
      backgroundPosition="center"
      flexDirection="column"
      overflow="hidden"
      templateRows="1fr minmax(100px, 7fr) 1fr"
    >
      <GridItem alignContent="center">
        <Flex
          direction={{base: 'column', lg: 'row'}}
          justify={{
            base: 'center',
            lg: 'space-between',
          }}
          align="center"
        />
      </GridItem>
      <GridItem
        background={`${colors.mld.neutral[900]}E6`}
        borderRadius="lg"
        color="mld.neutral.0"
      >
        <Box height="100%" overflow="auto" p="sm">
          <Flex minH="100%" align="center" justify="center">
            <Flex flexDirection="column">
              <Image src={congratsImage} height="100%" maxH="48vh" />
              <Text
                mt={{base: '0', md: '-lg'}}
                maxWidth="450px"
                mx="auto"
                textStyle="headline2"
                textAlign="center"
              >
                {t('signup.heading')}
              </Text>

              <Text
                maxWidth="450px"
                mx="auto"
                textStyle="body-intro"
                my="md"
                textAlign="center"
                color="mld.neutral.0"
              >
                {t('signup.body')}
              </Text>
              <Flex justifyContent="center">
                <Button
                  variant="primary"
                  onClick={() => navigate('/points')}
                  colorScheme="primary"
                  type="submit"
                  data-testid="continue-button"
                  size="lg"
                  mt="sm"
                >
                  {t('signup.submitButton')}
                  <ArrowRightIcon width="24px" height="24px" ml="xs" />
                </Button>
              </Flex>
            </Flex>
          </Flex>
        </Box>
      </GridItem>
    </Grid>
  )
}

export default withProviders(WelcomeScreen)
